import React, { useState } from "react";
import { motion } from "framer-motion";

const MapFuture = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      title: "The intelligent pathfinder",
      desc: "Our advanced agent orchestration engine cross-references your business workflows with sector metrics and private data to architect a dynamic, predictive agentic roadmap that scales as you grow."
    },
    {
      id: 1,
      title: "1-on-1 expert advisory",
      desc: "Direct technical advisory. Partner directly with vetted Google Developer Experts and Ivy League graduates for hands-on code reviews, compliance planning, and model architecture audits."
    },
    {
      id: 2,
      title: "The vector RAG navigator",
      desc: "Connect private databases securely. Query complex internal corporate records, knowledge-bases, and PDFs instantly using Retrieval-Augmented Generation (RAG) with 98% accuracy."
    },
    {
      id: 3,
      title: "Your enterprise sandbox",
      desc: "Test agent behaviors securely. Sandbox conversational LLMs, run safe playground testing, and monitor model performance logs in a sandboxed, isolated environment before deploying live."
    }
  ];

  return (
    <section className="py-16 px-6 max-w-7xl mx-auto text-zinc-800 dark:text-zinc-200">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        
        {/* Left Side: Mockup Image/Graphic (matches screenshot) */}
        <div className="lg:col-span-6 flex justify-center items-center bg-zinc-100 dark:bg-zinc-900 rounded-[32px] p-8 border border-zinc-200/40 dark:border-zinc-800/40 aspect-[4/3] relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-tr from-forest/5 to-transparent"></div>
          
          {/* Visual Diagram Mock (replicates screenshot graphic) */}
          <div className="w-full max-w-md bg-white dark:bg-zinc-950 rounded-3xl border border-zinc-200 dark:border-zinc-800 shadow-xl p-6 relative space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-3 h-3 rounded-full bg-red-400"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
              <div className="w-3 h-3 rounded-full bg-green-400"></div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="p-3 bg-zinc-50 dark:bg-zinc-900 rounded-xl border border-zinc-100 dark:border-zinc-800 text-[10px] space-y-2">
                <span className="font-bold text-zinc-800 dark:text-zinc-200">Data Source</span>
                <div className="h-1.5 w-12 bg-forest/20 rounded"></div>
                <div className="h-1.5 w-16 bg-zinc-200 dark:bg-zinc-700 rounded"></div>
              </div>
              <div className="p-3 bg-zinc-50 dark:bg-zinc-900 rounded-xl border border-zinc-100 dark:border-zinc-800 text-[10px] space-y-2">
                <span className="font-bold text-zinc-800 dark:text-zinc-200">Active Profile</span>
                <div className="h-1.5 w-10 bg-forest/20 rounded"></div>
                <div className="h-1.5 w-14 bg-zinc-200 dark:bg-zinc-700 rounded"></div>
              </div>
            </div>

            <div className="p-3 bg-orange-accent/10 rounded-xl border border-orange-accent/20 flex items-center justify-between text-xs text-orange-accent font-semibold">
              <span>⚡ Intelligent Matchmaking Active</span>
              <span className="text-[10px] bg-orange-accent text-white px-2 py-0.5 rounded-full">running</span>
            </div>

            <div className="border-t border-zinc-100 dark:border-zinc-800 pt-4 space-y-2">
              <span className="text-[10px] font-bold uppercase text-zinc-400">Model Routing</span>
              <div className="flex -space-x-1 overflow-hidden">
                <span className="inline-block h-6 w-6 rounded-full bg-zinc-200 dark:bg-zinc-800 ring-2 ring-white dark:ring-zinc-950 flex items-center justify-center text-[8px] font-bold">L3</span>
                <span className="inline-block h-6 w-6 rounded-full bg-zinc-300 dark:bg-zinc-700 ring-2 ring-white dark:ring-zinc-950 flex items-center justify-center text-[8px] font-bold">G4</span>
                <span className="inline-block h-6 w-6 rounded-full bg-zinc-400 dark:bg-zinc-600 ring-2 ring-white dark:ring-zinc-950 flex items-center justify-center text-[8px] font-bold">SD</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Accordion Tabs (matches screenshot) */}
        <div className="lg:col-span-6 space-y-8">
          <div className="space-y-4">
            <h2 className="text-3xl font-extrabold text-zinc-900 dark:text-white mb-2 leading-tight">
              Everything You Need to Map Your Future
            </h2>
          </div>

          <div className="space-y-3">
            {tabs.map((tab) => {
              const isSelected = activeTab === tab.id;
              return (
                <div 
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`p-5 rounded-2xl cursor-pointer transition-all duration-300 border-l-4 ${
                    isSelected 
                      ? "bg-emerald-50 dark:bg-emerald-950/20 border-forest" 
                      : "border-transparent hover:bg-zinc-50 dark:hover:bg-zinc-900/40"
                  }`}
                >
                  <h3 className={`text-base font-bold transition-colors ${
                    isSelected ? "text-forest" : "text-zinc-900 dark:text-zinc-300"
                  }`}>
                    {tab.title}
                  </h3>
                  {isSelected && (
                    <motion.p 
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      className="mt-3 text-xs font-light text-zinc-600 dark:text-zinc-400 leading-relaxed"
                    >
                      {tab.desc}
                    </motion.p>
                  )}
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
};

export default MapFuture;
